import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ActivatedRoute, Router } from '@angular/router';

import { MasterDataService } from '../../Services/MasterDataService';
import { PropertyBasicInfo, CallDescriptionLookup, GenericMaster, GenericMaster_String } from '../../Models/GlobalEntities'
import { RecurrenceConsoleService } from '../../Services/RecurrenceConsoleService';
import { ListRequest, RecurrenceSearch, RecurrenceFilterModel } from '../../Models/RequestModels';
import { ListResponse } from '../../Models/ResponseModels';
import { TopFilterStatModel } from '../../Models/CommonModels';
import {FilterTypes, AuthActionCodes, RecurrenceSort} from '../../Models/EnumModels';
import { RecurrenceFilter } from '../RecurrenceFilter/RecurrenceFilter';
import { RecurrencePopover } from '../RecurrencePopover/RecurrencePopover';
import * as alasql from 'alasql';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AppSettings } from '../../Library/AppSettings';

@Component({
    selector: 'RecurrenceConsole',
    templateUrl: './RecurrenceConsole.html'
})

export class RecurrenceConsole extends BaseComponent implements OnInit {
    @ViewChild('recurrenceFilter') recurrenceFilter: RecurrenceFilter;
    @ViewChild('recurrenceKey') recurrenceKey;

    PropStatModel: Array<TopFilterStatModel> = [];
    Model: ListResponse;
    DateFormat: string;
    FilterModel: RecurrenceFilterModel;
    RequestModel: RecurrenceSearch;
    Selected: any;
    SortByText: string = "";
    SortParams: Array<GenericMaster_String> = [];
    RecurrenceFilters: Array<FilterTypes> = [FilterTypes.CallDescription, FilterTypes.Dept, FilterTypes.Location, FilterTypes.RoomStatus, FilterTypes.EndPattern, FilterTypes.NextOccurrence];
    Propertylst: Array<PropertyBasicInfo>;
    AppSettings = AppSettings;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected recurrenceConsoleService: RecurrenceConsoleService, protected modalService: NgbModal,) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {
        this.Propertylst = this.GetProperties_Action(this._AuthActionCodes.RecurrenceView);
        this.RequestModel = new RecurrenceSearch();
        this.FilterModel = new RecurrenceFilterModel();
        this.FilterModel.Properties = [];
        this.FilterModel.SetDefaults();
        this.RequestModel.PropertyId = this.masterService.GetDefaultProperty_Action(AuthActionCodes.RecurrenceView);
        this.FilterModel.Properties[0] = this.RequestModel.PropertyId;
        this.DateFormat = this.masterService.GetPropertyDateFormat(this.RequestModel.PropertyId);
        this.CreateSortParams();
        this.PopulateTopFilters();
        this.GetData();
    }

    Refresh(): void {
        this.GetData();
    }

    PopulateTopFilters(): void {
        this.PropStatModel.push({
            Id: null,
            IconClass: 'fa fa-bars',
            Label: 'LBL.ALL',
            Value: 0
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: "Y",
            IconClass: 'fa fa-unlock-alt',
            Label: 'LBL.ACTIVE',
            Value: 0
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: "N",
            IconClass: 'fa fa-lock',
            Label: 'LBL.EXPIRED',
            Value: 0
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: "D",
            IconClass: 'fa fa-trash',
            Label: 'LBL.DELETED',
            Value: 0
        } as TopFilterStatModel);

    }

    FindStatus(Status: string): TopFilterStatModel {
        return this.PropStatModel.find(value => {
            return value.Id == Status;
        });
    }

    Transform_TopFilter(lst: any): void {
        if (lst == null)
            return;

        let totalCount = 0;

        for (let i = 0; i < this.PropStatModel.length; i++) {
            let row = this.PropStatModel[i];

            if (row != null && row.Id != null) {
                let count = alasql("Select COUNT(*) AS c from ? where StatusCode = ?", [lst, row.Id]);
                row.Value = count[0].c;
                totalCount = totalCount + row.Value;
            }
        }

        this.FindStatus(null).Value = totalCount;
    }

    GetData(): void {
        if (this.RequestModel == null)
            return;

        this.IsSubmitting = true;
        this.RequestModel.PageSize = 2000;
        this.RequestModel.PageNumber = 1;
        // this.recurrenceConsoleService.Recurrence_Query({
        //     Properties: [this.RequestModel.PropertyId],
        //     PageSize: 20,
        //     PageNumber: 1,
        //     OrderBy: null
        // })
        // .then(data => {
        //     if (data && data.HasError) {
        //         this.GetMultilingualToast(data.Errors[0].ErrorMessage, 'error')
        //     }
        //     if (data && !data.HasError) {
        //         this.Transform_TopFilter(data.Result);
        //         this.recurrenceConsoleService.Cache_RecurrenceData = _.cloneDeep(data.Result);
        //         this.SetData();
        //     }

        //     this.IsSubmitting = false;
        // }).catch(reason => {
        //     this.IsSubmitting = false;
        // });
        // this.recurrenceConsoleService.Recurrence_Search(this.RequestModel)
    }

    SetData(): void {
        if (this.FilterModel == null)
            return;
        this.Selected = null;
        this.Model = this.recurrenceConsoleService.Recurrence_Filter(this.FilterModel);
    }

    OnTopFilter(code: string): void {
        this.FilterModel.StatusCode = code;
        this.FilterModel.OrderBy = null;
        this.SetData();
    }

    OnSort(row: GenericMaster_String): void {
        this.FilterModel.OrderBy = row.Id as RecurrenceSort;
        this.SortByText = row.Name;
        this.SetData();
    }

    OnPropertyChange(propertyObj: PropertyBasicInfo): void {
        if (propertyObj.PropertyId != this.RequestModel.PropertyId) {
            this.RequestModel.PropertyId = propertyObj.PropertyId;
            this.DateFormat = this.masterService.GetPropertyDateFormat(this.RequestModel.PropertyId);
            this.FilterModel.Properties[0] = propertyObj.PropertyId;
            this.FilterModel.ClearFilter();
            this.GetData();
        }
    }

    ShowJobDetail(row): void {
        if (this.Selected == row)
            this.Selected = null;
        else {
            this.Selected = row;
        }
    }

    OnPageChange(): void {
        this.SetData();
    }

    OnMonthChange(value): void {
        if (value != 'All') {
            this.FilterModel.Months = +value;
        }
        else {
            this.FilterModel.Months = Number.MAX_SAFE_INTEGER;
        }

        this.SetData();
    }

    OnDelete(): void {
        this.SetData();
        this.Transform_TopFilter(this.recurrenceConsoleService.Cache_RecurrenceData);
    }

    OnSearch(keyword: any): void {
        if (this.FilterModel.Keyword && this.FilterModel.Keyword.trim() && this.FilterModel.Keyword.length > 2) {
            this.SetData();
        }

    }

    OpenFilterModal(): void {
        this.recurrenceFilter.Open(this.FilterModel);
    }

    ExportToExcel(): void {
        this.recurrenceConsoleService.ExportRecToExcel(this.FilterModel);
    }

    CreateSortParams(): void {
        this.SortParams = [
            { Id: "Location asc", Name: "BTN.BTN_LOCATION_ASC" },
            { Id: "Location desc", Name: "BTN.BTN_LOCATION_DESC" },
            { Id: "Department asc", Name: "BTN.BTN_DEPT_ASC" },
            { Id: "Department desc", Name: "BTN.BTN_DEPT_DESC" },
            { Id: "CallDescription Asc", Name: "BTN.BTN_CALLDESC_ASC" },
            { Id: "CallDescription Desc", Name: "BTN.BTN_CALLDESC_DESC" }
        ]
    }

    onClearFilter(): void {
        this.FilterModel.ClearFilter();
        this.SetData();
    }

    OpenKeyModal(): void {
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            size: 'lg',
            centered: true
        };
        this.modalService.open(this.recurrenceKey, ngbModalOptions);
    }
}
